(function () {
  'use strict';


  var routes = (window.Shopify && window.routes) || window.routes || {};
  function cartAddUrl() { return (window.routes && window.routes.cart_add_url) || '/cart/add'; }
  function cartUrl() { return (window.routes && window.routes.cart_url) || '/cart'; }

  /* ---------- Gallery slider ----------
     Same mechanism as Dawn's SliderComponent: a horizontal overflow
     track with CSS scroll snap, moved via scrollTo({behavior:'smooth'}).
     Touch swipe is therefore the browser's own, not simulated, and the
     active index is always read back from scrollLeft so arrows, swipe,
     thumbnails and variant changes can never disagree.

     Listeners are delegated from the document, so everything survives a
     Theme Editor re-render with no duplicate handlers. */

  function gRoot(node) {
    return node && node.closest ? node.closest('dox-gallery, [data-dox-gallery]') : null;
  }
  function gTrack(root) { return root ? root.querySelector('[data-dox-track]') : null; }
  function gSlides(root) {
    return root ? Array.prototype.slice.call(root.querySelectorAll('[data-dox-slide]')) : [];
  }
  function smooth() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'auto' : 'smooth';
  }

  function gIndex(root) {
    var track = gTrack(root);
    var slides = gSlides(root);
    if (!track || !slides.length) return 0;
    var w = slides[0].getBoundingClientRect().width || track.clientWidth || 1;
    var i = Math.round(track.scrollLeft / w);
    return Math.max(0, Math.min(slides.length - 1, i));
  }

  function gSync(root) {
    var track = gTrack(root);
    var slides = gSlides(root);
    if (!track || !slides.length) return;
    var i = gIndex(root);

    var thumbs = root.querySelectorAll('[data-dox-thumb]');
    for (var t = 0; t < thumbs.length; t++) {
      var on = String(thumbs[t].getAttribute('data-index')) === String(i);
      thumbs[t].setAttribute('aria-current', on ? 'true' : 'false');
      if (on && thumbs[t].scrollIntoView) {
        try { thumbs[t].scrollIntoView({ behavior: smooth(), block: 'nearest', inline: 'center' }); } catch (e) {}
      }
    }

    var prev = root.querySelector('[data-dox-gprev]');
    var next = root.querySelector('[data-dox-gnext]');
    if (prev) prev.toggleAttribute('disabled', i <= 0);
    if (next) next.toggleAttribute('disabled', i >= slides.length - 1);
  }

  function gGoTo(root, index) {
    var track = gTrack(root);
    var slides = gSlides(root);
    if (!track || !slides.length) return;
    var i = Math.max(0, Math.min(slides.length - 1, index));
    var left = slides[i].offsetLeft - track.offsetLeft;
    if (track.scrollTo) track.scrollTo({ left: left, behavior: smooth() });
    else track.scrollLeft = left;
    gSync(root);
  }

  function gGoToMediaId(mediaId) {
    if (!mediaId) return;
    var roots = document.querySelectorAll('dox-gallery, [data-dox-gallery]');
    for (var r = 0; r < roots.length; r++) {
      var slide = roots[r].querySelector('[data-dox-slide][data-media-id="' + String(mediaId) + '"]');
      if (slide) gGoTo(roots[r], parseInt(slide.getAttribute('data-index'), 10) || 0);
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var thumb = e.target.closest('[data-dox-thumb]');
    if (thumb) {
      e.preventDefault();
      gGoTo(gRoot(thumb), parseInt(thumb.getAttribute('data-index'), 10) || 0);
      return;
    }
    var prev = e.target.closest('[data-dox-gprev]');
    if (prev) { var rp = gRoot(prev); gGoTo(rp, gIndex(rp) - 1); return; }

    var next = e.target.closest('[data-dox-gnext]');
    if (next) { var rn = gRoot(next); gGoTo(rn, gIndex(rn) + 1); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var track = e.target && e.target.closest ? e.target.closest('[data-dox-track]') : null;
    if (!track) return;
    e.preventDefault();
    var root = gRoot(track);
    gGoTo(root, gIndex(root) + (e.key === 'ArrowRight' ? 1 : -1));
  });

  // Swipe and momentum scrolling land here; the index is read back from
  // scrollLeft once the gesture settles.
  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!track || !track.hasAttribute || !track.hasAttribute('data-dox-track')) return;
    window.clearTimeout(track._doxT);
    track._doxT = window.setTimeout(function () { gSync(gRoot(track)); }, 80);
  }, true);

  // Dispatched by <dox-purchase> when the chosen variant has media.
  document.addEventListener('dox:variant:media', function (e) {
    if (e && e.detail) gGoToMediaId(e.detail.mediaId);
  });

  // Shopify's own variant event, in case the form is ever swapped for a
  // native one. Changing the gallery never touches the form.
  document.addEventListener('variant:change', function (e) {
    var v = e && e.detail ? (e.detail.variant || e.detail) : null;
    if (v && v.featured_media && v.featured_media.id) gGoToMediaId(v.featured_media.id);
  });

  if (!customElements.get('dox-gallery')) {
    customElements.define('dox-gallery', class extends HTMLElement {
      connectedCallback() {
        var track = gTrack(this);
        if (!track) return;
        var start = parseInt(track.getAttribute('data-start-index'), 10) || 0;
        var self = this;
        // Jump (not animate) to the variant's media on first paint.
        requestAnimationFrame(function () {
          var slides = gSlides(self);
          if (start > 0 && slides[start]) {
            track.scrollLeft = slides[start].offsetLeft - track.offsetLeft;
          }
          gSync(self);
          tSync(self.querySelector('[data-dox-thumbs]'));
        });
        window.addEventListener('resize', function () {
          window.clearTimeout(self._doxR);
          self._doxR = window.setTimeout(function () { gSync(self); }, 150);
        }, { passive: true });
      }
    });
  }

  /* ---------- Thumbnail rail ----------
     Scrolls the existing strip horizontally. These arrows deliberately
     do NOT call gGoTo, so they never change the main image or the
     selected variant: they only reveal thumbnails that overflow. */

  function tStrip(node) {
    var root = gRoot(node);
    return root ? root.querySelector('[data-dox-thumbs]') : null;
  }

  function tStep(strip) {
    // Measured from the real thumbnail, never hardcoded.
    var first = strip.querySelector('[data-dox-thumb]');
    if (!first) return strip.clientWidth * 0.8;
    var gap = parseFloat(getComputedStyle(strip).columnGap || getComputedStyle(strip).gap || '0') || 0;
    var unit = first.getBoundingClientRect().width + gap;
    // Advance a visible page, keeping one thumbnail as context.
    var perView = Math.max(1, Math.floor(strip.clientWidth / unit) - 1);
    return unit * perView;
  }

  function tSync(strip) {
    if (!strip) return;
    var root = gRoot(strip);
    if (!root) return;
    var max = strip.scrollWidth - strip.clientWidth - 2;
    var prev = root.querySelector('[data-dox-tprev]');
    var next = root.querySelector('[data-dox-tnext]');
    // Hide both when nothing overflows.
    var overflows = max > 2;
    if (prev) prev.toggleAttribute('disabled', !overflows || strip.scrollLeft <= 2);
    if (next) next.toggleAttribute('disabled', !overflows || strip.scrollLeft >= max);
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var back = e.target.closest('[data-dox-tprev]');
    var fwd = back ? null : e.target.closest('[data-dox-tnext]');
    if (!back && !fwd) return;
    var btn = back || fwd;
    var strip = tStrip(btn);
    if (!strip) return;
    var amount = tStep(strip) * (back ? -1 : 1);
    if (strip.scrollBy) strip.scrollBy({ left: amount, behavior: smooth() });
    else strip.scrollLeft += amount;
  });

  document.addEventListener('scroll', function (e) {
    var strip = e.target;
    if (!strip || !strip.hasAttribute || !strip.hasAttribute('data-dox-thumbs')) return;
    window.clearTimeout(strip._doxTS);
    strip._doxTS = window.setTimeout(function () { tSync(strip); }, 80);
  }, true);

  window.addEventListener('resize', function () {
    window.clearTimeout(window._doxTSR);
    window._doxTSR = window.setTimeout(function () {
      var strips = document.querySelectorAll('[data-dox-thumbs]');
      for (var i = 0; i < strips.length; i++) tSync(strips[i]);
    }, 150);
  }, { passive: true });

  /* ---------- Accordion / FAQ ---------- */
  if (!customElements.get('dox-accordion')) {
    customElements.define('dox-accordion', class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('.dox-acc__btn').forEach((btn) => {
          btn.addEventListener('click', () => {
            var expanded = btn.getAttribute('aria-expanded') === 'true';
            var panel = document.getElementById(btn.getAttribute('aria-controls'));
            btn.setAttribute('aria-expanded', String(!expanded));
            var sign = btn.querySelector('.dox-acc__sign');
            if (sign) sign.textContent = expanded ? '+' : '–';
            if (panel) panel.hidden = expanded;
          });
        });
      }
    });
  }


  /* ---------- Carousel (testimonials etc.) ---------- */
  if (!customElements.get('dox-carousel')) {
    customElements.define('dox-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-dox-track]');
        var prev = this.querySelector('[data-dox-prev]');
        var next = this.querySelector('[data-dox-next]');
        if (prev) prev.addEventListener('click', () => this.scrollBy(-1));
        if (next) next.addEventListener('click', () => this.scrollBy(1));
      }
      scrollBy(dir) {
        if (!this.track) return;
        var card = this.track.querySelector(':scope > *');
        var amount = card ? card.getBoundingClientRect().width + 14 : this.track.clientWidth * 0.8;
        this.track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }
    });
  }


  /* ---------- Sticky add-to-cart ---------- */
  if (!customElements.get('dox-sticky-atc')) {
    customElements.define('dox-sticky-atc', class extends HTMLElement {
      connectedCallback() {
        var btn = this.querySelector('[data-dox-sticky-btn]');
        if (!btn) return;
        btn.addEventListener('click', () => {
          var purchase = document.querySelector('dox-purchase');
          if (purchase) {
            document.dispatchEvent(new CustomEvent('dox:atc:trigger'));
          } else {
            var target = document.querySelector('[data-dox-atc-anchor]');
            if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }
    });
  }

})();
